module.exports = __webpack_public_path__ + "static/media/invite1.9921b8ba.svg";